import { makeStyles, tokens } from "@fluentui/react-components";

export const useSearchModeLabelStyles = makeStyles({
  activeSearchMode: {
    fontWeight: tokens.fontWeightSemibold,
  },
  searchModeLabel: {
    color: tokens.colorNeutralForeground1,
    display: "flex",
    flexDirection: "row",
    columnGap: "4px",
    alignItems: "center",
  },
  spanWidth: {
    width: "200px",
  },
  disabledRadioLabel: {
    color: "#808080",
    opacity: 0.6,
  },
});
